export function LoadingSpinner() {
  return (
    <div style={{ padding: '24px 16px', textAlign: 'center' }}>
      <span style={{
        fontFamily: 'var(--mono)',
        fontSize: '12px',
        color: 'var(--orange)',
        letterSpacing: '2px',
      }}>
        LOADING...
      </span>
    </div>
  );
}
